import React from 'react';
import { Button, Typography } from '@mui/material';

const AppDownloadBtn = ({ img, text }) => {
    return (
        <Button
            size='small' className='flex gap-2'
            sx={{ color: 'primary.yorisWhite', backgroundColor: 'secondary.main', width: '100%', }}
        >
            <div className='pl-5 py-2 '>
                <img src={img} alt={img} />
            </div>
            <Typography sx={{ fontSize: '12px' }} className='py-2 pl-2 pr-5'>{text}</Typography>
        </Button>
    )
}

export default AppDownloadBtn